import React from 'react';
import { Expander, ExpanderTheme, ExpanderBorderStyle, ExpanderButtonStyle } from '@apply/components';
import { formatCurrency } from '@apply/ui';
import { MobileDrawHistoryEntry } from './MobileDrawHistoryEntry';
import { MobileDrawItem } from '../../../MobileDrawControl';

interface MobileDrawHistoryParameters {
    mobileDrawItem: MobileDrawItem;
}

export const MobileDrawHistory: React.FC<MobileDrawHistoryParameters> = ({ mobileDrawItem }) => {
    const maximumAmountFinanced = mobileDrawItem.budgetAmount - mobileDrawItem.equityAmount;

    return (
        <div className='mobileDrawHistory'>
            <Expander
                header='More'
                headerExpanded='Less'
                theme={ExpanderTheme.Gray}
                borderStyle={ExpanderBorderStyle.Rounded}
                buttonStyle={ExpanderButtonStyle.NoRounding}
                height='40px'
            >
                <div className='historyContent'>
                    {mobileDrawItem.budgetAmount && (
                        <MobileDrawHistoryEntry
                            item='Budget Amount'
                            amount={formatCurrency(mobileDrawItem.budgetAmount)}
                        />
                    )}
                    {mobileDrawItem.equityAmount && (
                        <MobileDrawHistoryEntry
                            item='Equity Requirement'
                            amount={formatCurrency(mobileDrawItem.equityAmount)}
                        />
                    )}
                    {maximumAmountFinanced >= 0 && (
                        <MobileDrawHistoryEntry
                            item='Maximum Amount Financed'
                            amount={formatCurrency(maximumAmountFinanced)}
                            topBorder={true}
                        />
                    )}
                    {mobileDrawItem.acquisitionAmount && (
                        <MobileDrawHistoryEntry
                            item='Funded at Close'
                            amount={formatCurrency(mobileDrawItem.acquisitionAmount)}
                        />
                    )}
                    {mobileDrawItem.drawHistory.map((historyAmount, i) => (
                        <MobileDrawHistoryEntry
                            key={`historyEntry-drawNumber${i}`}
                            item={`Draw #${i + 1}`}
                            amount={formatCurrency(historyAmount)}
                        />
                    ))}
                </div>
            </Expander>
        </div>
    );
};
